module.exports = __webpack_public_path__ + "static/media/bfm.2e91c8ef.png";